import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import React from 'react';
import styled from 'styled-components';
import type { SpinnerType } from '~/contracts/vdp';

export const Container = styled.div.attrs({
  className:
    'bg-white flex flex-col h-full justify-center pointer-events-none relative z-1 m:justify-end'
})`
  grid-column: 1;
  grid-row: 1;
  transition: opacity 0.5s;

  .mobile-capture & {
    grid-row: 2;
  }
`;

type HeroImageProps = React.HTMLProps<HTMLImageElement> & {
  isFallback: boolean;
  spinnerType: SpinnerType;
};

function getVerticalOffset({ spinnerType }: HeroImageProps): number {
  switch (spinnerType) {
    case '3d':
      return 6;
    case '64':
      return 12;
    default:
      return 9;
  }
}

export const HeroImage: React.FC<HeroImageProps> = styled.img.attrs({
  className: 'w-full z-1'
})`
  margin-top: ${getVerticalOffset}vh; // Line up with Spinner's focus
  opacity: ${(props: HeroImageProps) => (props.isFallback ? 1 : 0.7)};

  @media (min-width: ${legacyBreakpoints.m}px) {
    margin-top: 80px;
    opacity: 1;
  }
`;

export const BackgroundHeroImage: React.FC<
  React.HTMLProps<HTMLImageElement>
> = styled.img.attrs({
  className: 'absolute w-full'
})`
  height: 10000px; // Stretch out the top color
  top: 0;
`;
